import { Vue, Component } from 'vue-property-decorator'
import GrossingTouchSampleViewHeader from '@/modules/grossingModule/grossing-touch-view/views/grossing-touch-sample-view/grossing-touch-sample-view-header/grossing-touch-sample-view-header.vue'
import GrossingTouchPortionCard from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-portion-card/grossing-touch-portion-card.vue'
import GrossingTouchSubportionCard from '@/modules/grossingModule/grossing-touch-view/components/grossing-touch-subportion-card/grossing-touch-subportion-card.vue'
import GrossingTouchPortionSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-portion-sidepanel/grossing-touch-portion-sidepanel.vue'
import GrossingTouchSubportionSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-subportion-sidepanel/grossing-touch-subportion-sidepanel.vue'
import GrossingTouchProtocolsSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-protocols-sidepanel/grossing-touch-protocols-sidepanel.vue'
import GrossingTouchAssaysSidepanel from '@/modules/grossingModule/grossing-touch-view/sidepanels/grossing-touch-assays-sidepanel/grossing-touch-assays-sidepanel.vue'

@Component({
    components: {
        GrossingTouchSampleViewHeader,
        GrossingTouchPortionCard,
        GrossingTouchSubportionCard,
        GrossingTouchPortionSidepanel,
        GrossingTouchSubportionSidepanel,
        GrossingTouchProtocolsSidepanel,
        GrossingTouchAssaysSidepanel
    }
})

export default class GrossingTouchSampleTabPortions extends Vue {
    private portionSelectionBarActive !: boolean
    private subportionSelectionBarActive !: boolean
    private subportionPanelActive !: boolean
    private grossingPortions !: Array<object>
    private grossingSubportions !: Array<object>

    constructor() {
        super()
        this.portionSelectionBarActive = true
        this.subportionSelectionBarActive = false
        this.subportionPanelActive = true
        this.grossingPortions = [
            {
                label: '1',
                portionTypeEnum: 'PARAFFIN_BLOCK',
                fragmentOrientation: {
                    forDescription: 'Central',
                    forIconName: 'icon-pos-central'
                },
                incidentsCount: 1,
                attachmentsCount: 1,
                notes: 'Comment here',
                protocols: 1,
                numberOfFragments: 2,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                selected: true
            },
            {
                label: '2',
                portionTypeEnum: 'FROZEN_BLOCK',
                fragmentOrientation: null,
                incidentsCount: 1,
                attachmentsCount: 0,
                notes: '',
                status: {
                    code: 'VERIFIED',
                    name: 'Verificado'
                }
            },
            {
                label: '3',
                portionTypeEnum: 'FROZEN_BLOCK',
                fragmentOrientation: {
                    forDescription: 'Central',
                    forIconName: 'icon-pos-central'
                },
                incidentsCount: 0,
                attachmentsCount: 0,
                notes: '',
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                }
            },
            {
                label: '4',
                portionTypeEnum: 'PARAFFIN_BLOCK',
                fragmentOrientation: {
                    forDescription: 'Central',
                    forIconName: 'icon-pos-central'
                },
                incidentsCount: 0,
                attachmentsCount: 0,
                notes: '',
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                }
            },
            {
                label: '5',
                portionTypeEnum: 'VIRTUAL',
                fragmentOrientation: {
                    forDescription: 'Central',
                    forIconName: 'icon-pos-central'
                },
                incidentsCount: 0,
                attachmentsCount: 0,
                notes: '',
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                }
            },
            {
                label: '6',
                portionTypeEnum: 'PARAFFIN_BLOCK',
                fragmentOrientation: null,
                incidentsCount: 0,
                attachmentsCount: 0,
                notes: '',
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                }
            }
        ]
        this.grossingSubportions = [
            {
                label: 1,
                portionLabel: '',
                name: 'Hematosilina Eosina',
                assaygroup: {
                    name: 'Histopatología'
                },
                incidentsCount: 1,
                attachmentsCount: 2,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                generationPersonnel: 'DOMÍNGUEZ SÁNCHEZ LUIS',
                generationDate: '25/02/2022 13:32',
                cancelledBy: 'LÓPEZ SÁEZ LUCÍA',
                cancellationDate: '25/02/2022 14:07',
                selected: false
            },
            {
                label: 2,
                name: 'Hematosilina Eosina',
                assaygroup: {
                    name: 'Histopatología'
                },
                incidentsCount: 1,
                attachmentsCount: 0,
                status: {
                    code: 'REGISTERED',
                    name: 'Registrado'
                },
                petitioner: 'DOMÍNGUEZ SÁNCHEZ ANTONIO'
            }
        ]
    }
}
